import React from 'react';
import PropTypes from 'prop-types';
import PublishSubmitMenuModal from './PublishSubmitMenuModal';

const SubmitMenuModal = ({ modalData, setModalData,fromMoreActions }) => {
  return (
    <PublishSubmitMenuModal
      title={'Publish Assignment as a Benchmark Public Assignment'}
      isOpen={modalData}
      onClose={() => setModalData(false)}
      textboxLabel={'Name for the Benchmark Public Assignment'}
      submit={true}
      apiParamOptions={3}
      note={
        'Note that a Benchmark Assignment is intended for district-wide use and is controlled by an administrator. By submitting the assignment as a Benchmark, you are giving control to the administrator who will provide you with instructions on when to assign the benchmark to students. Making this a Benchmark assignment locks it immediately - only an administrator can unlock it in order to allow it to be accessed by students. Please press the Cancel button if this is not your intention'
      }
      helpText={
        'Submitting an assignment as a benchmark creates a special Public Assignment called a Benchmark Assignment. Benchmark Assignments cannot be modified in any way and administrators have access to reports displaying district-wide results.<br /><br />You should only use this option if you are working with an administrator to create benchmark assignments that are to be assigned to students in the school or district.<br /><br />The Benchmark Assignment is initially locked, which means it cannot be assigned. Only administrators can unlock a Benchmark Assignment.'
      }
      confirmationMsg={'Are you sure that you want to submit this assignment to an administrator as a special Benchmark assignment? Benchmark assignments are controlled by an administrator. Your students will not be able to access the assignment until unlocked by an administrator.'}
      fromMoreActions={fromMoreActions}
    />
  );
};

SubmitMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  fromMoreActions: PropTypes.bool
};

export default SubmitMenuModal;
